export default __webpack_public_path__ + "static/media/37t.41a66b58.jpg";